
import { useMemo } from 'react';
import { Profile } from '@/types/database.types';
import { filterUsers } from '../utils/userHelpers';

export const useUserFiltering = (users: Profile[] | null, searchQuery: string) => {
  const filteredUsers = useMemo(() => {
    return filterUsers(users, searchQuery);
  }, [users, searchQuery]);

  return { filteredUsers };
};
